module.exports = __webpack_public_path__ + "img/693b6dc.svg";